module.exports = __webpack_public_path__ + "static/media/triangle.82c13ecf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/triangle.svg
// module id = 128
// module chunks = 36